import { lazy } from 'react';

export const AuditLogList = lazy(() => import('./audit_log/AuditLogList'));
export const InOutReport = lazy(() => import('./in_out_log/InOutReport'));
export const UserStatusReport = lazy(() => import('./user_status/UserStatusReport'));
export const AdminReport = lazy(() => import('./admn_report/AdminReport'));
export const FinancialReport = lazy(() => import('./financial_report/FinancialReport'));
export const OccupancyReport = lazy(() => import('./occupancy_report/OccupancyReport'));
export const TicketResolutionReport = lazy(() => import('./ticket_resolution_report/TicketResolutionReport'));
export const VisitorTrafficReport = lazy(() => import('./visitor_traffic_report/VisitorTrafficReport'));
export const MonitoringAndLogs = lazy(() => import('./monitoring_and_logs/MonitoringAndLogs'));
export const AuditTrail = lazy(() => import('./audit_trail/AuditTrail'));
export const PlatformAnalytics = lazy(() => import('./platform_analytics/PlatformAnalytics'));